import axios from "axios";
import { config } from "config";

export const api = axios.create({
  baseURL: config.apiUrl,
});

api.interceptors.request.use(
  async (cfg) => {
    const [dirtyTokenId, dirtyTokenCSRF] = await Promise.all([
      localStorage.getItem(`@${config.appAgent}:token-id`),
      localStorage.getItem(`@${config.appAgent}:token-csrf`),
    ]);

    const tokenName = String(dirtyTokenId || "")
      .replace('"', "")
      .replace('"', "");

    const tokenValue = String(dirtyTokenCSRF || "")
      .replace('"', "")
      .replace('"', "");

    if (tokenName && tokenValue) {
      cfg.headers["token-id"] = tokenName;
      cfg.headers["token-csrf"] = tokenValue;
    }

    cfg.headers["app-lang"] = "pt-br";

    return cfg;
  },

  async (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  async (response) => {
    // console.log(response.headers['token-id'])
    // console.log(
    //   response.headers['token-csrf'],
    //   String(response.headers['token-csrf']).length,
    // )
    if (response.headers["token-id"] || response?.data?.token?.id) {
      localStorage.setItem(
        `@${config.appAgent}:token-id`,
        String(response.headers[`token-id`] || response?.data?.token?.id)
      );
    }
    if (response.headers[`token-csrf`] || response?.data?.token?.csrf) {
      localStorage.setItem(
        `@${config.appAgent}:token-csrf`,
        String(response.headers[`token-csrf`] || response?.data?.token?.csrf)
      );
    }

    return response;
  },
  async (error) => {
    console.log("error?.response?.data", error?.response?.data || error);
    // if (String(error?.response?.data?.errorCode || '').match('CSRFX')) {
    //   await Promise.all([
    //     AsyncStorage.removeItem(`@${config.appAgent}:client`),
    //     AsyncStorage.removeItem(`@${config.appAgent}:client-profile`),
    //     AsyncStorage.removeItem(`@${config.appAgent}:token-id`),
    //     AsyncStorage.removeItem(`@${config.appAgent}:token-csrf`),
    //   ])
    // }
    return Promise.reject(error);
  }
);
